import { http } from '../util/http'
import { API_KOTLIN_DOMAIN } from '../config'
import headers from './employeeSystemHeader'

// 获取收费类型
export const getChargeTypeList = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/identity/chargeTypes`,
  })
}

// 获取薪酬类型
export const getSalaryTypeList = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/identity/salaryTypes`,
  })
}

// 员工列表
export const getClubStaffList = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/employees`,
  })
}

// 查询用户员工权限及其它详情
export const getStaffDetails = (id) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/permissionMember/detail`,
    params: {
      employeeId: id,
    },
  })
}

// 新增或修改用户权限
export const addOrEditEmployee = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/permissionMember`,
    method: 'post',
    data,
  })
}

// 新增或修改班次时间
export const addShift = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/shift`,
    method: 'post',
    data,
  })
}

// 删除班次
export const deleteShift = (id) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/shift/disabled`,
    method: 'post',
    data: {
      id: id,
    },
  })
}

// 删除员工
export const deleteEmployee = (employeeId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/disabled`,
    method: 'post',
    data: {
      id: employeeId,
    },
  })
}

// 获取当前俱乐部所有班次
export const getClubAllShift = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/shift`,
  })
}

// 获取单日总员工考勤记录
export const attendanceDayRecord = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/attendance/dayRecord`,
    params,
  })
}

// 获取月度总员工考勤记录
export const attendanceMonthRecord = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/attendance/monthRecord`,
    params,
  })
}

// 获取审核列表
export const attendanceAllReview = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/attendance/allReview`,
    params,
  })
}

// 审核
export const attendanceReview = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/attendance/review`,
    method: 'post',
    data,
  })
}

// 获取具体日期总员工服务记录
export const serviceOfDay = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/service/day`,
    params,
  })
}

// 获取月度总员工服务记录
export const serviceOfMonth = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/service/month`,
    params,
  })
}

// 员工薪酬详情列表
export const salaryRecordList = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/salary/infos`,
    params,
  })
}

// 获取Purchase相关服务账单
export const purchaseServices = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/service/purchaseServices`,
    params,
  })
}

// 换绑会员
export const postRebindMember = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/permissionMember/rebind`,
    method: 'post',
    data,
  })
}

// 作废服务记录
export const voidService = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/service/void`,
    method: 'post',
    data,
  })
}

// 恢复已作废的服务记录
export const restoreService = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/service/void/restore`,
    method: 'post',
    data,
  })
}

// 获取作废记录列表
export const voidServiceList = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/service/void/list`,
    params,
  })
}



// WEBPACK FOOTER //
// ./src/api/employee.js